const MoneyMask = (n, hidePrefix = false) => {
  if (n === null) return null
  let options = {}
  if (!hidePrefix) options = { style: 'currency', currency: 'BRL' }
  if (hidePrefix) options = { minimumFractionDigits: 2 }
  return n.toLocaleString('pt-BR', options)
}

export default MoneyMask
